"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _View = _interopRequireDefault(require("react-native-web/dist/cjs/exports/View"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _ThemeProvider = require("../ThemeProvider");
var _utils = require("../utils");
var _StackView = require("../StackView");
var _Typography = _interopRequireDefault(require("../Typography"));
var _ColourBubble = _interopRequireDefault(require("./ColourBubble"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const [selectProps, selectedSystemPropTypes] = (0, _utils.selectSystemProps)([_utils.a11yProps, _utils.viewProps]);
const ColourToggle = /*#__PURE__*/_react.default.forwardRef((_ref, ref) => {
  let {
    tokens,
    variant,
    defaultColourId,
    items,
    onChange,
    ...rest
  } = _ref;
  const [currentColourId, setCurrentColourId] = _react.default.useState(defaultColourId);
  const getTokens = (0, _ThemeProvider.useThemeTokensCallback)('ColourToggle', tokens, variant);
  const {
    space
  } = getTokens();
  const {
    colourName: currentColourName = ''
  } = items.find(item => item.id === currentColourId) || '';
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_View.default, {
    ref: ref,
    ...selectProps(rest),
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Typography.default, {
      children: currentColourName
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_StackView.StackWrap, {
      space: space,
      accessibilityRole: "radiogroup",
      children: items.map((_ref2, index) => {
        let {
          id,
          colourHexCode,
          colourName
        } = _ref2;
        const colourBubbleId = id || `ColourBubble[${index}]`;
        const handleChangeColour = event => {
          setCurrentColourId(id);
          onChange?.(event, {
            id,
            colourHexCode,
            colourName
          });
        };
        return /*#__PURE__*/(0, _jsxRuntime.jsx)(_ColourBubble.default, {
          id: colourBubbleId,
          tokens: getTokens,
          isSelected: id === currentColourId,
          colourHexCode: colourHexCode,
          colourName: colourName,
          onPress: handleChangeColour
        }, colourBubbleId);
      })
    })]
  });
});
ColourToggle.displayName = 'ColourToggle';
ColourToggle.propTypes = {
  ...selectedSystemPropTypes,
  /**
   * Optional theme token overrides for the outer ColourToggle component
   */
  tokens: (0, _utils.getTokensPropType)('ColourToggle'),
  /**
   * Colour toggle variant.
   */
  variant: _utils.variantProp.propType,
  /**
   * Id of the selected color when component mounts
   */
  defaultColourId: _propTypes.default.string,
  /**
   * Array of objects containing specifics for each ColourBubble to be rendered in the group.
   */
  items: _propTypes.default.arrayOf(_propTypes.default.exact({
    colourHexCode: _propTypes.default.string,
    colourName: _propTypes.default.string,
    id: _propTypes.default.string
  })),
  /**
   * If provided, this function is called when the current selection of the color is changed of all currently `items`. Receives two parameters: item object selected and the event
   */
  onChange: _propTypes.default.func
};
var _default = exports.default = ColourToggle;